import type { AppRouteRecordRaw } from '@/types/router'
import { ROUTE_NAMES } from '@/types/router'

// 活动相关路由配置
export const activityRoutes: AppRouteRecordRaw[] = [
  {
    path: '/activity',
    name: ROUTE_NAMES.ACTIVITY,
    component: () => import('@/views/activity/index.vue'),
    meta: {
      titleKey: 'routeTitle.activity',
      keepAlive: false,
    },
  },
  {
    path: '/activity/rules',
    name: ROUTE_NAMES.ACTIVITY_RULES,
    component: () => import('@/views/activity/rules.vue'),
    meta: {
      titleKey: 'routeTitle.activityRules',
      keepAlive: false,
    },
  },
  {
    path: '/activity/invite',
    name: ROUTE_NAMES.ACTIVITY_INVITE,
    component: () => import('@/views/activity/invite.vue'),
    meta: {
      titleKey: 'routeTitle.activityInvite',
      keepAlive: false,
    },
  },
  {
    path: '/activity/signup',
    name: ROUTE_NAMES.ACTIVITY_SIGNUP,
    component: () => import('@/views/activity/signup.vue'),
    meta: {
      titleKey: 'routeTitle.activitySignup',
      keepAlive: false,
    },
  },
  {
    path: '/activity/work',
    name: ROUTE_NAMES.ACTIVITY_WORK_DETAIL,
    component: () => import('@/views/activity/work-detail.vue'),
    meta: {
      titleKey: 'routeTitle.activityWorkDetail',
      keepAlive: false,
    },
  },
  {
    path: '/activity/rankRecord',
    name: ROUTE_NAMES.ACTIVITY_RANK_RECORD,
    component: () => import('@/views/activity/rankRecord.vue'),
    meta: {
      titleKey: 'routeTitle.activityRankRecord',
      keepAlive: false,
    },
  },
  {
    path: '/activity/lottery',
    name: ROUTE_NAMES.ACTIVITY_LOTTERY,
    component: () => import('@/views/activity/lottery.vue'),
    meta: {
      titleKey: 'routeTitle.lottery',
      keepAlive: false,
    },
  },
  {
    path: '/activity/activity-center',
    name: ROUTE_NAMES.ACTIVITY_CENTER,
    component: () => import('@/views/activity/activityCenter.vue'),
    meta: {
      titleKey: 'routeTitle.activityCenter',
      keepAlive: false,
    },
  },
  {
    path: '/activity/prize-list',
    name: ROUTE_NAMES.ACTIVITY_PRIZE_LIST,
    component: () => import('@/views/activity/prizeList.vue'),
    meta: {
      titleKey: 'routeTitle.prizeList',
      keepAlive: false,
    },
  },
  {
    path: '/activity-poster',
    name: ROUTE_NAMES.ACTIVITY_POSTER,
    component: () => import('@/views/poster/ActivityPoster.vue'),
    meta: {
      titleKey: 'routeTitle.activityPoster',
      keepAlive: false,
    },
  },
  {
    path: '/activity/lottery-poster',
    name: ROUTE_NAMES.ACTIVITY_LOTTERY_POSTER,
    component: () => import('@/views/poster/lotteryPoster.vue'),
    meta: {
      titleKey: 'routeTitle.lotteryPoster',
      keepAlive: false,
    },
  },
  {
    path: '/activity/exchange-coupon',
    name: ROUTE_NAMES.ACTIVITY_EXCHANGE_COUPON,
    component: () => import('@/views/activity/exchangeCoupon.vue'),
    meta: {
      keepAlive: false,
    },
  },
] 